import axios from "./../../axiosMiddleware/index";
import { api } from "../../apiendpoints/index";

//POST API for check in check out for lunch,business,personalbusiness
export const CheckInOutTime = async (punchType, attendanceType, isSupplier, supplierName, toTime, Purpose, isBusinessPunch) => {
  const data = {
    punchType: punchType,
    inOutStatus: attendanceType,
    withSupplier: isSupplier,
    supplierName: isSupplier ? supplierName : null,
    ExpectedReturnTime: toTime,
    Purpose: Purpose
  };
  return axios.post(`${api.TIME_ATTENDANCE.CHECK_IN_OUT}`, data);
};

export const GetCheckInOutStatus = async (punchType) => {
  return axios.get(
    `${api.TIME_ATTENDANCE.CHECK_IN_OUT_STATUS}?AttendancePunchTypeId=${punchType}`
  );
};
export const AddOREditLeaveGatepass = async (data) => {
  return axios.post(`${api.TIME_ATTENDANCE.ADD_EDIT_LEAVE_GATE_PASS}`, data);
};
export const GetallLeaveGatepass = async (data) => {
  return axios.post(`${api.TIME_ATTENDANCE.GET_LEAVE_GATEPASS}`, data);
};
//POST API for the my time punch records
export const GetRecords = async (data) => {
  return axios.post(`${api.TIME_ATTENDANCE.RECORDS}`, data);
};

//GET API for whos in the building
export const GetEmployees = async () => {
  return axios.get(`${api.TIME_ATTENDANCE.BUILDING}`);
};

export const GetMyTimePunchRecords = async (
  data,
  config = {}
) => {
  return axios.post(
    `${api.TIME_ATTENDANCE.MY_TIME_PUNCH_RECORDS}`,
    data,
    config
  );
};

export const GetLateArrivalDashboard = async (
  data,
  config = {}
) => {
  return axios.post(
    `${api.TIME_ATTENDANCE.LATE_ARRIVAL_DASHBOARD}`,
    data,
    config
  );
};

export const GetTwoMinLateDashboard = async (
  data,
  config = {}
) => {
  return axios.get(
    api.TIME_ATTENDANCE.TWO_MIN_LATE_DASHBOARD,
    {
      ...config,
      params: {
        StartDate: data.StartDate,
        EndDate: data.EndDate,
        // Start: data.Start ?? 0,
        // Length: data.Length ?? 25,
        // SearchKeyword: data.SearchKeyword || undefined,
        // PersonId: data.PersonId ?? undefined,
        ...config.params,
      },
    }
  );
};




export const GetTwoMinLateEmployees = async (
  data,
  config = {}
) => {
  return axios.get(
    api.TIME_ATTENDANCE.TWO_MIN_LATE_EMPLOYEE_DETAILS,
    {
      ...config,
      params: {
        StartDate: data.StartDate ?? data.startDate,
        EndDate: data.EndDate ?? data.endDate,
        SearchKeyword:
          data.SearchKeyword ?? data.searchKeyword ?? undefined,
        Start: data.Start ?? data.start ?? 0,
        Length: data.Length ?? data.length ?? 25,
        PersonId: data.PersonId ?? data.personId ?? undefined,
        ...config.params,
      },
    }
  );
};




export const GetLateArrivalEmployeeDetails = async (
  data,
  config = {}
) => {
  return axios.post(
    `${api.TIME_ATTENDANCE.LATE_ARRIVAL_EMPLOYEE_DETAILS}`,
    data,
    config
  );
};